import { React, Component, Router, Link, Config, Icon, _ } from 'utils';
import moment from 'moment/src/moment';
import './resume.less';
import { Creators } from 'model';

function Box(props) {
	return <span className="info-box">{ props.children }</span>;
}

export default class Resume extends Component {

	handleChange = (event) => {
		var { model, formatter } = this.props;
		Creators.resumeSelected(model, event.target.checked);
	}

	render() {
		const { model, formatter, maxTitle } = this.props;

		const href = Config.baseUrl + 'resume/' + model.id;

        var edit_time = moment(model.last_update, "DD.MM.YYYY.");
        var now = moment();

        var diff_date = now.diff(edit_time, 'days');

		var timeWhenProfileWasChangedMessage = moment().add(-diff_date, 'days').fromNow();

		var vCity = '';
		if(model.city) {
			vCity = <Box><Icon name="map-marker" /> {model.city}</Box>;
		}

		var vEducation = '';
		if(model.education) {
			vEducation = <Box><Icon name="graduation-cap" /> {_(formatter.format(model.education))}</Box>
		}

		var vExperience = '';
		if(model.experience) {
			const yearsOfExpirience = Math.round(model.experience / 365 * 100) / 100;
			const total = `${yearsOfExpirience} ${_('years_expirience', 'godina')}`;
			vExperience = <Box><Icon name="briefcase" /> { total }</Box>
		}

		var css = 'resume';
		if(model.checked) {
			css += ' checked';
		}

		return <div className={ css }>
				<div className="row">
					<div className="col-md-12">
						<h4>
							<input type="checkbox" checked={ model.checked === true } onChange={this.handleChange} />
							<Link
								to={href}
								onClick={this.props.onClick}
							>{model.title.substr(0, maxTitle) + (model.title.length > maxTitle?' ...':'') }</Link>
						</h4>
					</div>

					<div className="col-md-12 resume-details">
						<div>{vCity} {vEducation} {vExperience}</div>
						<div><Icon name="edit" /> {_('Zadnja izmjena')}, {model.last_update}, {timeWhenProfileWasChangedMessage}</div>
					</div>
				</div>
			</div>;
	}
}


// WEBPACK FOOTER //
// ./src/modules/app/resumes/Resume.js